const block_icons     = {
    heading_icon: <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 24 24"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#ef0606"
      d="M22.5 6h-21C.673 6 0 5.327 0 4.5v-3C0 .673.673 0 1.5 0h21c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-21-5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM23.5 9H.5a.5.5 0 010-1h23a.5.5 0 010 1zM23.5 12H.5a.5.5 0 010-1h23a.5.5 0 010 1zM23.5 15H.5a.5.5 0 010-1h23a.5.5 0 010 1zM23.5 18H.5a.5.5 0 010-1h23a.5.5 0 010 1zM23.5 21H.5a.5.5 0 010-1h23a.5.5 0 010 1zM23.5 24H.5a.5.5 0 010-1h23a.5.5 0 010 1z"
      data-original="#000000"
    ></path>
  </svg>  
}

export default block_icons;